import { Package } from "lucide-react"

import { StatusBadge } from "../ui/status-badge"

// The small inline "needs offer" pill, shared by the feed-preview table rows
// and the storefront grid/table cards (a variant/config eligible to list with
// no marketplace offer yet). Warning-toned (actionable), not destructive — it
// doesn't block the build. `title` is the native-tooltip text; the feed-preview
// table wraps this in a richer <Tooltip> instead.
export function NeedsOfferPill({ title }: { title?: string }) {
  return (
    <StatusBadge tone="warning" size="sm" title={title}>
      <Package className="size-3" />

      <span>needs offer</span>
    </StatusBadge>
  )
}
